import type { FunctionComponent, PropsWithChildren } from 'react';
import Dialog, { Close } from '../molecules/Dialog';
import SpeechBubble from '../atoms/SpeechBubble';
import Text from '../atoms/Text';
import AutofitText from '../molecules/AutofitText';
import PersonaDetailsOverlay from '../molecules/PersonaDetailsOverlay';
import type { Persona } from '../../data/Personas';
import type { Delay } from '../../utils/animation';

export interface Props {
	persona: Persona;
	text: string[];
	onClose?: () => void;
	highlightClose?: boolean;
	highlightCloseDelay?: Delay;
}

const PersonaDialog: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	const {
		children,
		onClose,
		persona,
		text,
		highlightClose = true,
		highlightCloseDelay = 'long'
	} = props;

	return (
		<Dialog
			closeButton={
				<Close
					onClose={onClose}
					highlightClose={highlightClose}
					highlightCloseDelay={highlightCloseDelay}
				/>
			}
		>
			<PersonaDetailsOverlay persona={persona} />
			<SpeechBubble
				anchor="left_bottom"
				position="absolute"
				left="calc(11% + 38vmin + 2%)"
				right="6%"
				top="8%"
				bottom="28%"
			>
				<AutofitText>
					<Text content={text} />
				</AutofitText>
			</SpeechBubble>
			{children}
		</Dialog>
	);
};

export default PersonaDialog;
